const formatDateTimeLocal = (date = new Date()) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const MESSAGES = {
  ERROR_FETCH: "Error fetching data.",
  ERROR_CREATE: "Failed to create/update meter.",
  ERROR_DELETE: "Failed to delete meter.",
  ERROR_INSTALL: "Failed to install meter.",
  ERROR_REMOVE: "Failed to remove meter.",
  ERROR_TRANSFER: "Failed to transfer meter.",
  SUCCESS_CREATE: "Meter created successfully.",
  SUCCESS_UPDATE: "Meter updated successfully.",
  SUCCESS_DELETE: "Meter deleted successfully.",
  SUCCESS_INSTALL: "Meter installed successfully.",
  SUCCESS_REMOVE: "Meter removed successfully.",
  SUCCESS_TRANSFER: "Meter transferred successfully.",
};

export const DEFAULT_FORM_VALUES = {
  meter_id: "",
  meter_serial: "",
  meter_make: "",
  meter_model: "",
  meter_type_ndx: 1, // Default to first meter type (likely "Mechanical")
  unit_native_ndx: 1, // Default to first unit native (likely "Gallons")
  gal_conversion_ndx: 1, // Default to first conversion (likely "1.0" - no conversion)
  rollover_num: "",
  notes: "",
};

export const DEFAULT_INSTALL_VALUES = {
  well_ndx: null,
  installed_at: formatDateTimeLocal(),
  installation_note: "",
};

export const DEFAULT_REMOVE_VALUES = {
  removed_at: formatDateTimeLocal(),
  installation_note: "",
};

export const DEFAULT_TRANSFER_VALUES = {
  from_well_ndx: null,
  to_well_ndx: null,
  transferred_at: formatDateTimeLocal(),
  installation_note: "",
};

export const QUERY_OPTIONS_CACHE = {
  staleTime: Infinity,
  cacheTime: Infinity,
};
